import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { responseHandler } from "@msuite/ui/utils";
import { type ContactFormSchema, contactSchema } from "@msuite/utils/schemas";
import type { Tables } from "@msuite/utils/types";
import { FormProvider, useForm } from "react-hook-form";
import { ContactForm } from "@/forms/contact-form";
import { client } from "@/hono";
import { useContacts } from "@/hooks/use-contacts";

/** Props Interface */
interface AddContactModalProps extends ModalProps {
	onComplete?: (contact: Tables<"contacts">) => void | Promise<void>;
}

export function AddContactModal({ isOpen, onClose, onComplete }: AddContactModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(contactSchema),
	});
	const { refetch } = useContacts();

	/* Functions */
	async function handleOnSubmit(json: ContactFormSchema) {
		try {
			const response = await client.contacts.index.$post({
				json,
			});
			const data = await responseHandler(response);
			if (data.contact) {
				onClose();
				await refetch();
				await onComplete?.(data.contact);
			}
		} catch (error) {
			console.error(error);
		}
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				isOpen={isOpen}
				onClose={onClose}
				title={t("contacts.add_contact")}
				onSubmit={methods.handleSubmit(handleOnSubmit)}
			>
				<Modal.Body>
					<ContactForm />
				</Modal.Body>
				<Modal.FooterForm />
			</Modal>
		</FormProvider>
	);
}
